import { PublicMobileShell } from "../components/PublicMobileShell";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Map, CloudSun, Users, ClipboardList, QrCode, Route, Apple, Play, Sparkles } from "lucide-react";

const FEATURES = [
  { icon: Map, title: "Karta lovišča", desc: "Meje lovišč (ZGS), lokacija v živo, obračanje karte v smer pogleda, krogi razdalje, offline." },
  { icon: CloudSun, title: "Vreme, veter & luna", desc: "3-dnevna napoved, smer vetra z animacijo raznašanja vonja, lunine mene, radar padavin." },
  { icon: Users, title: "Skupinski lov", desc: "Ustvari lov, povabi solovce s QR kodo, lokacija članov (v živo), klepet med lovom." },
  { icon: ClipboardList, title: "Evidenca odstrela", desc: "Zapis s sliko in težo, samodejne razmere ob strelu, statistika sezone, GPX uvoz/izvoz." },
  { icon: QrCode, title: "Vezice", desc: "Skeniranje vezice (LZS, ZGS), dostop do članskih strani LZS v aplikaciji." },
  { icon: Route, title: "Načrtovanje", desc: "Markerji, načrt lova, deljenje dosežkov." },
];

const StoreBadge = ({ icon: Icon, top, bottom, testid }) => (
  <a
    href="#"
    className="inline-flex items-center gap-3 bg-slate-950 hover:bg-slate-800 text-white rounded-xl px-5 py-2.5 transition shadow-md"
    data-testid={testid}
  >
    <Icon className="h-7 w-7" />
    <span className="text-left leading-tight">
      <span className="block text-[10px] uppercase tracking-wide text-slate-300">{top}</span>
      <span className="block text-base font-semibold">{bottom}</span>
    </span>
  </a>
);

export default function AplikacijaPage() {
  return (
    <PublicMobileShell>
      <section className="relative hero-bg text-white overflow-hidden">
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <div className="absolute top-10 -left-10 w-72 h-72 bg-amber-200/30 rounded-full blur-3xl" />
          <div className="absolute bottom-10 -right-10 w-96 h-96 bg-white/20 rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-4xl mx-auto px-4 py-16 md:py-24 text-center space-y-6" data-testid="aplikacija-hero">
          <Badge className="bg-amber-400 text-primary border-amber-500 hover:bg-amber-400 font-semibold">MOBILNA APLIKACIJA</Badge>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Dober Pogled — mobilna aplikacija za lovce
          </h1>
          <p className="text-lg md:text-xl text-amber-100 font-medium">Varen in boljši pogled na lov.</p>
          <p className="max-w-2xl mx-auto text-white/90">
            Karta lovišč, vreme in veter, luna, žive lokacije solovcev ter evidenca odstrela — vse na enem mestu, tudi brez signala.
          </p>
          <div className="flex flex-wrap gap-3 justify-center pt-2">
            <StoreBadge icon={Apple} top="Prenesite v" bottom="App Store" testid="badge-appstore" />
            <StoreBadge icon={Play} top="Na voljo v" bottom="Google Play" testid="badge-googleplay" />
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-14">
        <h2 className="text-base md:text-lg font-bold text-emerald-900 text-center mb-8 uppercase tracking-wide">Kaj zmore aplikacija</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {FEATURES.map((f) => (
            <Card key={f.title} className="hover:shadow-lg transition-shadow" data-testid={`feature-${f.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <CardContent className="pt-6">
                <div className="w-10 h-10 rounded-lg bg-emerald-900/10 flex items-center justify-center mb-3">
                  <f.icon className="h-5 w-5 text-emerald-900" />
                </div>
                <h3 className="font-semibold text-emerald-900 mb-1">{f.title}</h3>
                <p className="text-sm text-slate-600">{f.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 pb-6">
        <Card className="bg-gradient-to-br from-emerald-900 to-emerald-800 text-white border-0 shadow-2xl">
          <CardContent className="py-10 text-center space-y-5">
            <Sparkles className="h-8 w-8 mx-auto text-amber-300" />
            <h2 className="text-2xl md:text-3xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
              Prenesi Dober pogled App in preizkusi Pro z 14-dnevnim brezplačnim preizkusom.
            </h2>
            <div className="flex flex-wrap gap-3 justify-center">
              <StoreBadge icon={Apple} top="Prenesite v" bottom="App Store" testid="cta-appstore" />
              <StoreBadge icon={Play} top="Na voljo v" bottom="Google Play" testid="cta-googleplay" />
            </div>
          </CardContent>
        </Card>
      </section>
    </PublicMobileShell>
  );
}
